define('home/views/LoginOverlayView',[
    'underscore',

    'home/views/common/LoginFormView',
    'home/templates/loginOverlay',
], function (
    _,

    LoginFormView,
    loginOverlayTemplate
) {
    'use strict';

    /**
     * A view that shows as either a sticky footer or as an overlay that
     * prompts the user to log in, and contains the form to do so.
     *
     * Does not require a model.
     * Initialize can optionally take in prompt, which is the message to
     * show to the user above the sign in options.
     */
    var LoginOverlayView = LoginFormView.extend({
        events: _.defaults({
            'click [data-action~=show-login-overlay]': 'showAsOverlay',
        }, LoginFormView.prototype.events),

        template: loginOverlayTemplate,
        templateHelpers: function () {
            return {
                prompt: this.prompt,
            };
        },

        className: 'login-overlay__wrapper hidden-sidebar',

        initialize: function (options) {
            LoginFormView.prototype.initialize.call(this, options);

            this.prompt = options && options.prompt;
        },

        showAsOverlay: function () {
            this.$el
                .removeClass('is-footer')
                .addClass('is-overlay');

            this.trigger('shown:overlay');
        },

        showAsFooter: function (shouldShow) {
            this.$el
                .removeClass('is-overlay')
                .toggleClass('is-footer', Boolean(shouldShow));
        },
    });

    return LoginOverlayView;
});

